"use strict";
var BoundNodeCallbackObservable_1 = require("./BoundNodeCallbackObservable");
exports.bindNodeCallback = BoundNodeCallbackObservable_1.BoundNodeCallbackObservable.create;
//# sourceMappingURL=bindNodeCallback.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/rxjs/observable/bindNodeCallback.js
 ** module id = 189
 ** module chunks = 1
 **/